<template>
  <div class="order-return-superuser">
    <div>
      <div class="input-column">
        <validation-observer
          ref="observerAccount"
          tag="form">
          <div class="input-column__container">
            <div class="input-column__container">
              <oie-base-input
                v-model="superuserOptions.shippingCost"
                :error-messages="errors"
                :label-text="t('rmaShippingCost')"></oie-base-input>
            </div>
            <oie-base-dropdown
              v-model="superuserOptions.shippingAgent"
              initial-text="Select..."
              :options="shippingAgents"
              :is-large="false"
              :use-full-width="true"
              :use-thin-border="true"
              :label-text="t('rmaShippingAgent') + '*'"></oie-base-dropdown>

            <oie-base-dropdown
              v-if="shippingAgentServices.length > 0"
              v-model="superuserOptions.shippingAgentService"
              initial-text="Select..."
              :options="shippingAgentServices"
              :is-large="false"
              :use-full-width="true"
              :use-thin-border="true"
              :label-text="t('rmaShippingAgentService') + '*'"></oie-base-dropdown>

            <oie-base-checkbox
              v-model="superuserOptions.createConsignmentNote"
              is-for="order-return-superuser-create-consignment-note"
              :text="t('rmaCreateConsignmentNote')"></oie-base-checkbox>

            <oie-base-dropdown
              v-model="superuserOptions.documentToCustomer"
              default-selected="DEFAULT"
              initial-text="Select..."
              :options="documentToCustomerOptions"
              :is-large="false"
              :use-full-width="true"
              :use-thin-border="true"
              :label-text="t('rmaDocumentToCustomer') + '*'"></oie-base-dropdown>
          </div>
        </validation-observer>
      </div>
    </div>

    <div class="order-return-superuser__actions-container">
      <div class="order-return-superuser__actions-right">
        <oie-base-button
          v-if="issueKey && !createRmaAlongWithIssue"
          v-epi-edit="'createOrderReturnButtonLabel'"
          :disabled="!(superuserOptions.shippingAgent && superuserOptions.shippingAgentService && superuserOptions.documentToCustomer && superuserOptions.documentToCustomer)"
          :text="t('createRmaLabel')"
          css-classes="button--with-border button--green order-return-superuser__action-button"
          :use-full-width="true"
          @click="createRma"></oie-base-button>

        <oie-base-button
          v-if="!issueKey || createRmaAlongWithIssue"
          v-epi-edit="'createOrderReturnButtonLabel'"
          :disabled="!(superuserOptions.shippingAgent && superuserOptions.shippingAgentService && superuserOptions.documentToCustomer && superuserOptions.documentToCustomer)"
          :text="t('rmaCreateIssueAndRma')"
          css-classes="button--with-border button--green order-return-superuser__action-button"
          :use-full-width="true"
          @click="createOrderReturnInParentAndRma"></oie-base-button>
      </div>
    </div>
  </div>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  props: {
    issueKey: {
      type: String,
      default: null
    },
    orderNumber: {
      type: String,
      default: null
    },
    createRmaAlongWithIssue: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    shippingSettings: null,
    shippingAgents: [],
    isOpen: true,
    superuserOptions: {
      createOrderReturnAndRma: false,
      shippingCost: 0,
      createRma: false,
      shippingAgent: null,
      shippingAgentService: null,
      documentToCustomer: null,
      createConsignmentNote: true,
      rma: null,
      consignmentNoteUrl: null
    }
  }),
  computed: {
    documentToCustomerOptions() {
      let options = []

      // reasons.push({ text: this.tStatic('orderReturnReasonDropdownOption1'), value: 1 })
      options.push({ text: 'Standard', value: 'DEFAULT' })
      options.push({ text: 'Skicka inte', value: 'NONE' })

      return options
    }, /*,    shippingAgents() {
      let agents = []

      // reasons.push({ text: this.tStatic('orderReturnReasonDropdownOption1'), value: 1 })
      agents.push({ text: 'Postnord', value: 'POSTNORD' })
      // agents.push({ text: 'Schenker', value: 'SCHENKER' })
      agents.push({ text: 'DHL', value: 'DHL' })
      // agents.push({ text: 'UPS', value: 'UPS' })
      // agents.push({ text: 'DSV', value: 'DSV' })

      return agents
    } */
    shippingAgentServices() {
      if (!this.superuserOptions.shippingAgent) { return [] }

      const filteredSettings = this.shippingSettings.filter(a => a.shippingAgent === this.superuserOptions.shippingAgent)

      if (!filteredSettings) { return [] }

      let services = []

      for (let i = 0; i < filteredSettings.length; i++) {
        services.push({ text: filteredSettings[i].shippingAgentService, value: filteredSettings[i].shippingAgentService })
      }

      return services
    }
  },
  watch: {
    superuserOptions: {
      handler: function (newSuperuserOptions, oldSuperuserOptions) {
        this.publish('order-return-superuser-updated', newSuperuserOptions)
      },
      deep: true
    }
  },
  mounted() {
    httpService.get(`order-return/shipping-settings?orderNumber=${this.orderNumber}`).then((response) => {
      this.shippingSettings = response.data

      for (let i = 0; i < this.shippingSettings.length; i++) {
        const shippingAgent = this.shippingSettings[i].shippingAgent

        if (!this.shippingAgents.some(item => item.value === shippingAgent)) {
          this.shippingAgents.push({ text: shippingAgent, value: shippingAgent })
        }
      }
    })

    this.$watch(
      'superuserOptions.shippingAgent',
      (newVal, oldVal) => {
        this.superuserOptions.shippingAgentService = null
      }
    )

    this.subscribe('order-return-created', (orderReturn) => {
      this.issueKey = orderReturn.issueKey

      if (this.superuserOptions.createOrderReturnAndRma) {
        this.superuserOptions.createOrderReturnAndRma = false
        this.createRma()
      }
    })
  },
  methods: {
    createRma() {
      const rmaJson = {
        issueKey: this.issueKey,
        orderNumber: this.orderNumber,
        shippingCost: this.superuserOptions.shippingCost,
        shippingAgent: this.superuserOptions.shippingAgent,
        shippingAgentService: this.superuserOptions.shippingAgentService,
        documentToCustomer: this.superuserOptions.documentToCustomer,
        createConsignmentNote: this.superuserOptions.createConsignmentNote
      }

      httpService.post(`order-return/rma`, rmaJson).then((response) => {
        this.superuserOptions.rma = response.data.rma
        this.superuserOptions.consignmentNoteUrl = response.data.consignmentNoteUrl
        this.publish('order-return-superuser-rma-created', this.superuserOptions)
      })
    },
    createOrderReturnInParentAndRma() {
      this.$parent.$refs.observer.validate().then((valid) => {
        if (valid) {
          this.superuserOptions.createOrderReturnAndRma = true
        }
      })
    }
  }
}
</script>

<style lang="scss">
  .order-return-superuser__actions-right {
    width: 100%;
    margin-top: 1rem;

    @include media(medium) {
      max-width: 24rem;
      width: 100%;
      margin-left: auto;
    }
  }

  .rma-confirmation {
      margin-bottom: 2rem;
  }
</style>
